import type { MaskType } from 'maska'
import type { InjectionKey } from 'vue'
import type { RuleArray } from '../rules'

export interface UIPhoneInputDefaults {
    rules?: RuleArray
    // UIInput resolves function masks itself, so they may return maska's candidate-list shape.
    mask?: MaskType | ((input: string) => string[])
}

export const PHONE_INPUT_DEFAULTS_KEY = Symbol() as InjectionKey<UIPhoneInputDefaults>

export interface UIPhoneInput {
    /** @example '+44' */
    prefix: string
    /** @example '## ## ## ##' */
    mask?: MaskType
    /** @example 'Mobile number' */
    label: string
    /** @example '/media/uk-flag.svg' */
    flagSrc: string
    /** @description Regex pattern to strip from phone number before prefixing @example '^0' */
    replace?: string
}
